import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-8" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "mr-4" }
const _hoisted_5 = { class: "my-2" }
const _hoisted_6 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_7 = { class: "font-weight-bold mr-2" }
const _hoisted_8 = { class: "pa-4" }
const _hoisted_9 = { class: "d-flex mb-8" }
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { align: "top" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('nap.weather')), 1),
            _createVNode(_component_v_select, {
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              items: _ctx.weatherOptions,
              "item-title": "label",
              "item-value": "value",
              modelValue: _ctx.weather,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.weather) = $event))
            }, null, 8, ["items", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "9" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('nap.temperatureHumidity')), 1),
              _createVNode(_component_v_btn, {
                variant: "outlined",
                color: "primary",
                small: "",
                onClick: _ctx.openModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("+ " + _toDisplayString(_ctx.$t('common.add')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.airConditions, (ac, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  class: "mr-2"
                }, [
                  (i > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " | "))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(ac.time) + ":00 " + _toDisplayString(ac.temperature) + "℃ " + _toDisplayString(ac.humidity) + "%", 1),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    "x-small": "",
                    disabled: _ctx.isDeleting,
                    onClick: ($event: any) => (_ctx.deleteAirCondition(ac.id)),
                    variant: "text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { "x-small": "" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (_ctx.isDeleting)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              class: "my-2",
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isAirConditionModalOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAirConditionModalOpen) = $event)),
      "max-width": "540"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_spacer),
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('nap.addTemperatureHumidity')), 1),
                _createVNode(_component_v_spacer)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('nap.time')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    type: "number",
                    min: "0",
                    max: "24",
                    suffix: ":00",
                    modelValue: _ctx.newAirConditionTime,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAirConditionTime) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('nap.temperature')), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    type: "number",
                    suffix: "℃",
                    min: "-10",
                    max: "60",
                    modelValue: _ctx.newAirConditionTemper,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAirConditionTemper) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('nap.humidity')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    type: "number",
                    suffix: "%",
                    min: "0",
                    max: "100",
                    modelValue: _ctx.newAirConditionHumi,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newAirConditionHumi) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (_ctx.isCreating)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    color: "primary",
                    indeterminate: "",
                    class: "mb-4"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  large: "",
                  disabled: !_ctx.airConditionCreateButtonValid || _ctx.isCreating,
                  onClick: _ctx.addAirCondition
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_v_spacer)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}